import React, { useEffect, useRef } from 'react'
import Pagination from '../molecules/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../../redux/rootReducer'
import { FETCH_OFFERS, SET_CURRENT_PAGE } from '../../redux/paginatedOffersReducer'
import { ListOffer } from 'dealer-types'

interface PaginatedOffersProps {
  component: React.FC<ListOffer>
}

const PaginatedOffers = ({ component }: PaginatedOffersProps): JSX.Element => {
  const Component = component
  const dispatch = useDispatch()
  const currentPage = useSelector((state: RootReducer) => state.paginatedOffersReducer.currentPage)
  const totalItems = useSelector((state: RootReducer) => state.paginatedOffersReducer.totalCount)
  const totalPages = useSelector((state: RootReducer) => state.paginatedOffersReducer.totalPages)
  const offers = useSelector((state: RootReducer) => state.paginatedOffersReducer.offers)
  const tab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const offersWrapperRef = useRef<HTMLDivElement>(null)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[tab])
  const buyNowFiler = useSelector((state: RootReducer) => state.tableToolsReducer.filters[tab].buyNowFiler)

  useEffect(() => {
    dispatch(FETCH_OFFERS())
  }, [currentPage, dispatch, filters, buyNowFiler])

  useEffect(() => {
    dispatch(SET_CURRENT_PAGE({ currentPage: 1 }))
  }, [filters, buyNowFiler, dispatch])

  const headerHeight = 200
  return (
    <div
      ref={offersWrapperRef}
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
      className="h-full w-full overflow-scroll">
      <div className="">
        {offers.map((offer) => (
          <Component key={offer.id} {...offer} />
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalItems={totalItems}
        totalPages={totalPages}
        onPageChange={(page) => {
          dispatch(SET_CURRENT_PAGE({ currentPage: page }))
          offersWrapperRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
        }}
      />
    </div>
  )
}

export default PaginatedOffers
